"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tools = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var react_redux_1 = require("react-redux");
var translate_1 = require("utils/translate");
var sok_ui_1 = require("@caddigital/sok-ui");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var download_1 = require("utils/download");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        documents: state.bid.tender.documents,
        token: state.auth.current.token,
        selectedLanguage: selectedLanguage
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    downloadFiles: function (files, urls, token) {
        return function () {
            if (files.length > 1 ||
                files.filter(function (f) { return f.type === 'FOLDER'; }).length > 0) {
                var retVal = dispatch(ToastActions.addNewToast((0, translation_1.getLocalization)('files/toast/download/loading-title'), (0, translation_1.getLocalization)('files/toast/download/loading-text'), 'NORMAL', [], undefined, 0));
                var uuid_1 = retVal.payload.uuid;
                (0, download_1.downloadFiles)(token, files, urls, undefined, function () { return dispatch(ToastActions.removeToast(uuid_1)); }, { includeSubFolders: 'true', includeSelf: 'true' });
                return;
            }
            window.open(__UPLOADSERVERURL__ + '/files/' + files[0].uuid, '_blank');
        };
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('BidTenderCardTools'), recompose_1.pure);
exports.Tools = enhance(function (props) {
    var state = (0, react_redux_1.useSelector)(exports.mapStateToProps);
    var dispatchers = (0, exports.mapDispatchToProps)((0, react_redux_1.useDispatch)());
    var _a = React.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = React.useState(false), includeDocuments = _b[0], setIncludeDocuments = _b[1];
    var reportUrl = props.participant
        ? "/bid/".concat(props.currentBid.id, "/participant/").concat(props.participant.id, "/report")
        : '#';
    var folders = [];
    if (includeDocuments) {
        if (state.documents.requestToParticipantRoot) {
            folders.push(state.documents.requestToParticipantRoot);
        }
        if (state.documents.suitabilityRoot) {
            folders.push(state.documents.suitabilityRoot);
        }
        if (state.documents.tenderRoot) {
            folders.push(state.documents.tenderRoot);
        }
    }
    if (props.currentBid.procerement.reliablePartnerReport &&
        state.documents.reliablePartnerRoot &&
        state.documents.reliablePartner.length > 0) {
        folders.push(state.documents.reliablePartnerRoot);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.ToolsSidebarWrap, { className: 'briefcase-view-tools-container' },
            React.createElement(sok_ui_1.ToolsSidebar, { className: 'bid-tendercard-tools', headerText: (0, translation_1.getLocalization)('bid/participantcard/tools/header') },
                React.createElement(sok_ui_1.ToolButton, { color: 'gray', text: (0, translation_1.getLocalization)('bid/participantcard/tools/downloadCard'), onClick: function () { return setIsOpen(true); }, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-arrow-down' }) }),
                React.createElement(sok_ui_1.ToolButton, { color: 'blue', text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/download'), onClick: dispatchers.downloadFiles(state.documents.selectedDocuments, [], state.token), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-cloud-download' }), disabled: state.documents.selectedDocuments.length === 0 }))),
        React.createElement(sok_ui_1.Overlay, { isOpen: isOpen, onClose: alert },
            React.createElement(sok_ui_1.SideMenu, { className: 'sok-tendercard-export', isOpen: isOpen, docked: false, orientation: 'right' },
                React.createElement(sok_ui_1.Header, { onClose: function () { return setIsOpen(false); } }, (0, translation_1.getLocalization)('bid/participantcard/export/header')),
                React.createElement(sok_ui_1.Container, null,
                    React.createElement("div", { className: 'sok-tendercard-export-content' },
                        React.createElement("p", null, (0, translation_1.getLocalization)('bid/participantcard/export/includeDocuments/label')),
                        React.createElement(sok_ui_1.Input, { type: 'radio', name: 'includedocuments', label: (0, translation_1.getLocalization)('bid/participantcard/export/includeDocuments/no'), value: !includeDocuments, onChange: function () { return setIncludeDocuments(false); } }),
                        React.createElement(sok_ui_1.Input, { type: 'radio', name: 'includedocuments', label: (0, translation_1.getLocalization)('bid/participantcard/export/includeDocuments/yes'), value: includeDocuments, onChange: function () { return setIncludeDocuments(true); } }),
                        folders.length > 0 ? (React.createElement(sok_ui_1.Button, { color: 'green', onClick: function () { return (dispatchers.downloadFiles(folders, [reportUrl], state.token)(),
                                setTimeout(function () { return (setIsOpen(false), setIncludeDocuments(false)); }, 200)); }, text: (0, translation_1.getLocalization)('bid/participantcard/export/create') })) : (React.createElement("a", { className: 'sok-button sok-button-color-green', onClick: function () {
                                return setTimeout(function () { return (setIsOpen(false), setIncludeDocuments(false)); }, 200);
                            }, href: "".concat(__APIBASEURL__, "api").concat(reportUrl) }, (0, translation_1.getLocalization)('bid/participantcard/export/create'))))),
                React.createElement(sok_ui_1.Footer, null,
                    React.createElement(sok_ui_1.Button, { color: 'blue', onClick: function () { return setIsOpen(false); }, text: (0, translation_1.getLocalization)('bid/participantcard/export/hide') }))))));
});
